<template>
  <div class="date-selector">
    <el-select class="select-date" v-model="year" @change="changeTime">
      <el-option
        v-for="item in yearList"
        :key="item"
        :label="item"
        :value="item">
      </el-option>
    </el-select>
    <el-select class="select-date" v-model="month" @change="changeTime">
      <el-option
        v-for="item in monthList"
        :key="item"
        :label="item"
        :value="item">
      </el-option>
    </el-select>
    <el-select class="select-date" v-model="day" @change="changeTime">
      <el-option
        v-for="item in dayList"
        :key="item"
        :label="item"
        :value="item">
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'time',
    event: 'change',
  },
  props: {
    time: Number,
    startTime: {
      type: String,
      default: '1970/1/1',
    },
    endTime: {
      type: String,
      default: () => {
        const d = new Date()
        const year = d.getFullYear() - 18
        const month = d.getMonth() + 1
        return `${year}/${month}/${d.getDate()}`
      },
    },
  },
  data() {
    return {
      year: 1970,
      month: 1,
      day: 1,
    }
  },
  computed: {
    startDate() {
      const list = this.startTime.split(/\/|-/)
      return {
        year: +(list[0]),
        month: +(list[1]),
        day: +(list[2])
      }
    },
    endDate() {
      const list = this.endTime.split(/\/|-/)
      return {
        year: +(list[0]),
        month: +(list[1]),
        day: +(list[2])
      }
    },
    yearList() {
      const list =[]
      for(var i = this.startDate.year; i <= this.endDate.year; i++) {
        list.push(i)
      }
      return list
    },
    monthList() {
      // let start = 1
      // if (this.year === this.startDate.year) {
      //   start = this.startDate.month
      // }
      // let end = 12
      // if (this.year === this.endDate.year) {
      //   end = this.endDate.month
      // }
      const list = []
      for (var i = 1; i <= 12; i++) {
        list.push(i)
      }
      return list
    },
    dayList() {
      // let start = 1
      // if (this.year === this.startDate.year && this.month === this.startDate.month) {
      //   start = this.startDate.day
      // }
      let end = this.getLastDate(this.year, this.month)
      // if (this.year === this.endDate.year && this.month === this.endDate.month) {
      //   end = this.endDate.day
      // }
      const list = []
      for (var i = 1; i <= end; i++) {
        list.push(i)
      }
      return list
    }
  },
  watch: {
    time() {
      this.getDate()
    },
  },
  created() {
    this.getDate()
  },
  methods: {
    getDate() {
      let time = this.time || Date.now()
      if (new Date(this.startTime).getTime() > time) time = this.startTime
      if (new Date(this.endTime).getTime() < time) time = this.endTime
      const d = new Date(time)
      this.year = d.getFullYear()
      this.month = d.getMonth() + 1
      this.day = d.getDate()
    },
    getLastDate(y, m) {
      if ([1, 3, 5, 7, 8, 10, 12].includes(m)) return 31
      if ([4, 6, 9, 11].includes(m)) return 30
      if (y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0)) return 29
      else return 28
    },
    changeTime() {
      this.$emit('change', new Date(`${this.year}/${this.month}/${this.day}`).getTime())
    },
  }
}
</script>
<style lang="scss" scoped>
  .date-selector {
    @include flex(space-between);
    .select-date {
      flex: 1;
      & /deep/ .el-input__inner {
        background: #F9F9F9;
        border: 1px solid $color-split;
        border-radius: 8px;
        padding: 0 13px;
        width: 100%;
        height: 44px;
        @include flex(space-between);
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-1;
      }
      &:not(:first-child) {
        margin-left: 16px;
      }
    }
  }
</style>
